export default "__VITE_ASSET__66f7bd4b__"